import { render, staticRenderFns } from "./NewOtherExpenses.vue?vue&type=template&id=a3d18954&scoped=true&"
import script from "./NewOtherExpenses.vue?vue&type=script&lang=js&"
export * from "./NewOtherExpenses.vue?vue&type=script&lang=js&"
import style0 from "./NewOtherExpenses.vue?vue&type=style&index=0&id=a3d18954&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3d18954",
  null
  
)

export default component.exports